import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['source', 'select'];

  static values = {
    url: String,
    idAttribute: String,
    displayAttribute: String,
    blankOption: String,
  };

  handleSelectChange () {
    this.populateSelect(this.sourceTarget.value);
  }

  populateSelect (sourceId) {
    const idPlaceholder = this.urlValue.lastIndexOf('/') + 1;
    const sourceUrl = this.urlValue.substring(0, idPlaceholder);
    const selectBox = this.selectTarget;
    const displayAttribute = this.displayAttributeValue;
    const idAttribute = this.idAttributeValue;
    const blankOption = this.blankOptionValue;

    fetch(`${sourceUrl}${sourceId}`, {
      credentials: 'same-origin',
    })
      .then(response => response.json())
      .then((data) => {
        selectBox.focus();
        selectBox.innerHTML = '';
        if (data.length === 0) {
          this.appendOption(selectBox, null, blankOption);
        } else {
          data.forEach((item) => {
            this.appendOption(
              selectBox,
              item[`${idAttribute}`],
              item[displayAttribute],
            );
          });
        }
      });
  }

  // eslint-disable-next-line class-methods-use-this
  appendOption (select, value, innerHTML) {
    const opt = document.createElement('option');
    opt.value = value;
    opt.innerHTML = innerHTML;
    select.appendChild(opt);
  }
}
